export default __webpack_public_path__ + "static/media/ursinebrawl2.2efd9d2b.png";